export function parseCommaSeparatedMenus(value) {
  if (value === null || value === undefined) return [];
  const str = String(value);
  return str
    .split(",")
    .map((v) => v.trim())
    .filter(Boolean);
}

function uniquePush(target, values) {
  for (const v of values) {
    const s = String(v ?? "").trim();
    if (!s) continue;
    if (target.includes(s)) continue;
    target.push(s);
  }
}

export function mergeRepresentativeMenus(dbMenus, registerTagString) {
  const merged = [];
  uniquePush(merged, Array.isArray(dbMenus) ? dbMenus : []);
  uniquePush(merged, parseCommaSeparatedMenus(registerTagString));
  return merged;
}

export function buildRepresentativeMenusStorageKey(storeBusinessNumber) {
  const sbn = String(storeBusinessNumber || "").trim();
  return sbn ? `representative_menus:${sbn}` : "representative_menus:";
}

export function getEditedRepresentativeMenus(storeBusinessNumber) {
  try {
    const key = buildRepresentativeMenusStorageKey(storeBusinessNumber);
    const raw = localStorage.getItem(key);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (!Array.isArray(parsed)) return null;
    const normalized = parsed
      .map((v) => (typeof v === "string" ? v.trim() : ""))
      .filter(Boolean);
    return normalized.length > 0 ? normalized : null;
  } catch {
    return null;
  }
}

export function setEditedRepresentativeMenus(storeBusinessNumber, menus) {
  const key = buildRepresentativeMenusStorageKey(storeBusinessNumber);
  const normalized = (Array.isArray(menus) ? menus : [])
    .map((v) => String(v ?? "").trim())
    .filter(Boolean);

  if (normalized.length === 0) {
    localStorage.removeItem(key);
    return;
  }

  localStorage.setItem(key, JSON.stringify(normalized));
}

export function getEffectiveRepresentativeMenus({
  storeBusinessNumber,
  dbMenus,
  conciergeMenus,
  registerTag,
}) {
  const edited = getEditedRepresentativeMenus(storeBusinessNumber);
  if (edited && edited.length > 0) return edited;

  const normalizedDbMenus = Array.isArray(dbMenus)
    ? dbMenus.map((v) => String(v ?? "").trim()).filter(Boolean)
    : [];

  if (normalizedDbMenus.length > 0) return normalizedDbMenus;

  const normalizedConciergeMenus = Array.isArray(conciergeMenus)
    ? conciergeMenus.map((v) => String(v ?? "").trim()).filter(Boolean)
    : [];

  if (normalizedConciergeMenus.length > 0) return normalizedConciergeMenus;

  return parseCommaSeparatedMenus(registerTag);
}
